<template>
  <div>
    <Head title="Editar Cuenta" />

    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center mb-8">
        <h1 class="text-3xl font-bold">Editar Cuenta</h1>
        <Link 
          :href="`/admin/accounts/${account.id}`" 
          class="btn-gray"
        >
          Volver
        </Link>
      </div>

      <div class="bg-white shadow overflow-hidden sm:rounded-lg">
        <form @submit.prevent="submit">
          <div class="px-4 py-5 sm:p-6">
            <div class="grid grid-cols-1 gap-6">
              <!-- Nombre -->
              <div>
                <label class="block text-sm font-medium text-gray-700">Nombre</label>
                <input 
                  v-model="form.name" 
                  type="text" 
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
                <div v-if="form.errors.name" class="mt-1 text-sm text-red-600">
                  {{ form.errors.name }}
                </div>
              </div>

              <!-- Email -->
              <div>
                <label class="block text-sm font-medium text-gray-700">Email</label>
                <input 
                  v-model="form.email" 
                  type="email" 
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
                <div v-if="form.errors.email" class="mt-1 text-sm text-red-600">
                  {{ form.errors.email }}
                </div>
              </div>

              <!-- Plan -->
              <div>
                <label class="block text-sm font-medium text-gray-700">Plan</label>
                <select 
                  v-model="form.plan" 
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                >
                  <option value="free">Free</option>
                  <option value="entrepreneur">Entrepreneur</option>
                  <option value="sme">SME</option>
                  <option value="enterprise">Enterprise</option>
                </select>
                <div v-if="form.errors.plan" class="mt-1 text-sm text-red-600">
                  {{ form.errors.plan }}
                </div>
              </div>

              <!-- Fecha de Expiración -->
              <div>
                <label class="block text-sm font-medium text-gray-700">Fecha de Expiración</label>
                <input 
                  v-model="form.plan_expires_at" 
                  type="date" 
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
                <div v-if="form.errors.plan_expires_at" class="mt-1 text-sm text-red-600">
                  {{ form.errors.plan_expires_at }}
                </div>
              </div>
            </div>
          </div>

          <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
            <button 
              type="submit" 
              class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              :disabled="form.processing"
            >
              Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  name: 'AccountEdit',

  components: {
    Head,
    Link,
  },

  layout: Layout,

  props: {
    account: Object,
  },

  setup(props) {
    const form = useForm({
      name: props.account.name,
      email: props.account.email,
      plan: props.account.plan,
      plan_expires_at: props.account.plan_expires_at ? props.account.plan_expires_at.split('T')[0] : '',
    })

    return { form }
  },

  methods: {
    submit() {
      this.form.put(`/admin/accounts/${this.account.id}`)
    },
  },
}
</script> 